var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowW1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3636 2.99969C35.3636 1.34284 34.0204 -0.000307474 32.3636 -0.000306884L5.36359 -0.00030857C3.70674 -0.00030857 2.36359 1.34284 2.36359 2.99969C2.36359 4.65655 3.70674 5.99969 5.36359 5.99969H29.3636V29.9997C29.3636 31.6565 30.7067 32.9997 32.3636 32.9997C34.0204 32.9997 35.3636 31.6565 35.3636 29.9997L35.3636 2.99969ZM2.12109 33.2422L4.24241 35.3635L34.4849 5.12101L32.3636 2.99969L30.2423 0.878372L-0.000226557 31.1209L2.12109 33.2422Z",
    fill: "#F3F0EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowW1);
export default __webpack_public_path__ + "static/media/Arrow_W1.d3ef7bd9480241701ca35dc4a2db6eb1.svg";
export { ForwardRef as ReactComponent };